<template>
  <div id="mandala"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue";
import colorTool from "@/utils/colorTool";
const {changeToRgb} = colorTool()


const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let type = ref(null) // min 1 - 10 max
let animateSpeed = ref(null) // min 1.2 -2 max
let high = ref(null)
let low = ref(null)
let nowTemperature = ref(null)
let backgroundColor = ref('rgb(0,0,0)')
let drawPot = ref(0)



const handleDynamicAnimateMode = (high, low, now, animateMode = 12) => {
  // 動畫模式
  type.value = 1 + animateMode * 5

  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 10) // 將高低差 分為 10個單位, 1單位

  // 現在溫度range
  let nowRange = Math.trunc((now - low) / lowHeightRange)
  // 設定速度 & animateMode
  if (nowRange <= 1) animateSpeed.value = 1.2
  else if (nowRange >= 10) animateSpeed.value = 2
  else animateSpeed.value = 1.2 + (nowRange * 0.08)
}
const handleChangeAnimateMode = (AnimateMode = 12, rotateSpeed) => {
	let td = 5  // type 1 - 1 0 的差
  let sd = rotateSpeed | 1
	let m = AnimateMode
  type.value = 1 + m * td
  animateSpeed.value =  1.2 * (sd * 0.08)
}


const mandalaAnimate = (sketch) => {
	let cw = defaultWidth.value
	let ch = defaultHeight.value
  let num = 360;
  let chr;
  let hu;
  let h;
  let f = 10;      // this line sets spectrum linearity correction
  let ang;
  let incr;
  let rad;
  let mlt;
  let radSpiral;
  let xIn;
  let yIn;
  let x;
  let y;
	sketch.setup = () => {
    sketch.createCanvas(cw, ch)//
		sketch.colorMode(sketch.HSB, 360, 100, 100, 255);
    sketch.background(0);
		hu = sketch.random(360);//隨機數字，用來當作起始顏色的色相
    rad = (cw / 1.46);//半徑
    incr = sketch.PI;
	}

	sketch.draw = () => {
    drawPot.value ++
    sketch.clear();
    sketch.background(backgroundColor.value);
    xIn = sketch.width / 2;
    yIn = sketch.height / 2;
    for (let i = 1; i < num; i++) {
      ang = i * type.value; //角度
      mlt = i / 360; //倍率
      radSpiral = mlt * rad; //半徑螺旋？
      x = sketch.width / 2 + sketch.cos(ang) * radSpiral;
      y = sketch.height / 2 + sketch.sin(ang) * radSpiral;
      chr = (hu+i)%360;
      h = chr + f * sketch.sin(3 * chr / 57);
      sketch.stroke(h%360, 255, 255); // 固定顏色
      sketch.line(xIn, yIn, x, y);
      xIn = x;
      yIn = y;
    }
    type.value += animateSpeed.value * 0.00015 * sketch.sin(sketch.TWO_PI * sketch.frameCount / 1500);
    hu++
	}
	sketch.windowResized = function () {
		cw = document.documentElement.clientWidth
		ch = document.documentElement.clientHeight
		sketch.resizeCanvas(cw, ch, true)
    rad = (cw / 1.46) //半徑
	}
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 7200) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(mandalaAnimate, 'mandala')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(mandalaAnimate, 'mandala')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    AnimateMode
  } = effectThemeData


  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  if (IsDynamicMode.toString() === 'false') {
    handleChangeAnimateMode(AnimateMode, rotateSpeed)
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    handleDynamicAnimateMode(HighValue, LowValue, nowTemperature.value, AnimateMode)
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(mandalaAnimate, 'mandala')
})


onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  backgroundColor.value = 'rgb(0,0,0)'
  type.value = null
  animateSpeed.value = null
  high.value = null
  low.value = null
  initAnimate()
})

</script>
